export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Déconnexion"])}
      },
      "en": {
        "logout": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Logout"])}
      }
    }
  })
}
